import Datalayer from './../datalayer/datalayer';

/**
 * Cart
 *
 * @module cart
 */
const component = {

	/**
	 * Init module
	 */
	init: () => {

		window.theme = window.theme || {};
    	window.theme.cart = component;
	},

	/**
	 * Get minicart data
	 */
	get: () => {

		return new Promise((resolve, reject) => {

			Datalayer.getCart().then(cart => {
				resolve(cart);
			});
		});
	},

	/**
	 * Add a product to the cart by parameters
	 */
	add: (id, qty, properties, trigger = true, formData) => {

		return new Promise((resolve, reject) => {

			Datalayer.addToCart(id, qty, properties, formData).then(cart => {
				if (trigger) {
					component.triggerEvent('addtocart', {
						'cart' : cart,
						'productAdded': {
							'id' : id,
							'qty' : qty,
							'properties' : properties,
							'fbtProductURL': formData.get('fbtProductURL')
						}
					});
				}
				resolve(cart);
			}).catch(function(error) {
				reject(error);
			});
		});
	},

	/**
	 * Remove product from cart
	 */
	remove: (id) => {

		return new Promise((resolve, reject) => {

			Datalayer.removeItemFromCart(id).then(cart => {
				component.triggerEvent('remove', { 'cart' : cart });
				resolve(cart);
			});
		});
	},

	/**
	 * Update product from cart
	 */
	update: (id, qty, properties) => {

		return new Promise((resolve, reject) => {

			Datalayer.updateItemFromCart(id, qty, properties).then(cart => {
				component.triggerEvent('update', { 'cart' : cart });
				resolve(cart);
			}).catch(function(error) {
				reject(error);
			});
		});
	},

	/**
	 * Get item data from cart
	 */
	getItem: (id) => {

		return new Promise((resolve, reject) => {

			let result = null;

			// TODO: Implement a cache approach to avoid make a request for each item
			component.get().then(cartData => {

				if (cartData.items) {

					result = cartData.items.filter(item => {
						return item.id == id;
					});
				}

				resolve(result[0]);
			});
		});
	},

	/**
	 * Trigger event
	 */
	triggerEvent: (eventName, data) => {

        let event = new CustomEvent(eventName, {'detail': data});

        window.dispatchEvent(event);
    },
};

export default component;
